import { bool, string, object } from "prop-types";
import React from "react";

import { MultiSelect as KendoMultiSelect } from "@progress/kendo-react-dropdowns";
import { FieldWrapper } from "@progress/kendo-react-form";
import { Error as ErrorLabel, Hint, Label } from "@progress/kendo-react-labels";

export const MultiSelect = (fieldRenderProps: {
  [x: string]: any;
  validationMessage: any;
  touched: any;
  label: any;
  id: any;
  valid: any;
  disabled: any;
  hint: any;
  wrapperStyle: any;
}) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = React.useRef(null);

  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hintId = showHint ? `${id}_hint` : "";
  const errorId = showValidationMessage ? `${id}_error` : "";
  const labelId = label ? `${id}_label` : "";

  return (
    <FieldWrapper>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <KendoMultiSelect
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
          ref={editorRef}
          valid={valid}
          id={id}
          disabled={disabled}
          {...others}
        />
        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <ErrorLabel id={errorId}>{validationMessage}</ErrorLabel>
        )}
      </div>
    </FieldWrapper>
  );
};

MultiSelect.displayName = "MultiSelect";
MultiSelect.propTypes = {
  valid: bool,
  defaultValue: object,
  id: string,
  optional: bool,
  label: string,
  hint: string,
  validationMessage: string,
  visited: bool,
};
